
<!-- Froala Editor component -->
<component :is="currentTag">
  <slot></slot>
</component>
